import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const Container = styled.div`
  ${tw`flex flex-col bg-gray-900 text-white min-h-screen py-8 px-4 w-full items-center box-border`}
`;

const PageContainer = styled.div`
  ${tw`text-sm text-gray-400 w-full md:w-3/4 box-border max-w-full min-w-0`}
`;

const BackButtonSkeleton = styled(Skeleton)`
  ${tw`w-32 h-10 mb-4`}
  background-color: rgba(75, 85, 99, 0.5);
`;

const VehicleHeader = styled.div`
  ${tw`flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6`}
`;

const VehicleTitle = styled.div`
  ${tw`flex flex-col`}
`;

const PriceInfo = styled.div`
  ${tw`flex flex-col items-end mt-4 lg:mt-0`}
`;

const ActionButtons = styled.div`
  ${tw`grid grid-cols-1 md:grid-cols-3 gap-4 mb-8`}
`;

const ContentContainer = styled.div`
  ${tw`grid grid-cols-1 lg:grid-cols-3 gap-6 box-border`}
`;

const PhotosSection = styled.div`
  ${tw`col-span-1 lg:col-span-2 bg-gray-800 rounded-lg overflow-hidden box-border`}
  border: 1px solid #374151;
`;

const InfoSection = styled.div`
  ${tw`col-span-1 bg-gray-800 rounded-lg overflow-hidden box-border`}
  border: 1px solid #374151;
`;

const ContactSection = styled.div`
  ${tw`col-span-1 lg:col-span-3 bg-gray-800 rounded-lg box-border mb-10 w-full max-w-full min-w-0`}
  border: 1px solid #374151;
`;

const DarkerSkeleton = styled(Skeleton)`
  background-color: rgba(75, 85, 99, 0.5);
`;

const InfoItem = styled.div`
  ${tw`flex items-center py-3 border-b border-gray-700 last:border-b-0 px-4`}
`;

const ViewDealerCarSkeleton: React.FC = () => {
  return (
    <Container>
      <PageContainer>
        <BackButtonSkeleton />

        <VehicleHeader>
          <VehicleTitle>
            <DarkerSkeleton width="250px" height="30px" className="mb-2" />
            <DarkerSkeleton width="150px" height="20px" />
          </VehicleTitle>
          <PriceInfo>
            <DarkerSkeleton width="100px" height="24px" className="mb-2" />
            <DarkerSkeleton width="120px" height="30px" className="mb-1" />
            <DarkerSkeleton width="80px" height="16px" className="mb-2" />
            <DarkerSkeleton width="100px" height="24px" className="mb-1" />
            <DarkerSkeleton width="60px" height="16px" />
          </PriceInfo>
        </VehicleHeader>

        <ActionButtons>
          {[1, 2, 3].map((_, i) => (
            <DarkerSkeleton key={i} width="100%" height="46px" />
          ))}
        </ActionButtons>

        <ContentContainer>
          <PhotosSection>
            <div className="relative w-full">
              <DarkerSkeleton width="100%" height="450px" />
            </div>
            <div className="p-4">
              <DarkerSkeleton width="100%" height="40px" />
            </div>
          </PhotosSection>

          <InfoSection>
            <DarkerSkeleton width="100%" height="50px" />

            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((_, i) => (
              <InfoItem key={i}>
                <DarkerSkeleton width="30px" height="30px" className="mr-4" />
                <div className="flex-1">
                  <DarkerSkeleton width="80px" height="16px" className="mb-1" />
                  <DarkerSkeleton width="120px" height="20px" />
                </div>
              </InfoItem>
            ))}
          </InfoSection>

          <ContactSection>
            <DarkerSkeleton width="100%" height="50px" />
            <div className="p-6">
              <DarkerSkeleton width="100%" height="200px" />
              <DarkerSkeleton width="100%" height="46px" className="mt-4" />
            </div>
          </ContactSection>
        </ContentContainer>
      </PageContainer>
    </Container>
  );
};

export default ViewDealerCarSkeleton;
